export default __webpack_public_path__ + "static/media/petar_xl.fb7ccf43.jpg";